import './cropper_component.scss'
import { Controller } from 'stimulus'
import Cropper from 'cropperjs'

export default class extends Controller {
  static targets = ['image']

  open = (file, cropSuccessAction, cropCancelledAction): void => {
    this.element.classList.add('cropper--active')
    this.element.focus()
    this.imageTarget.src = file.dataURL
    this.cropper = new Cropper(this.imageTarget, {
      strict: false,
      autoCrop: true,
      autoCropArea: 1,
      initialAspectRatio: 1,
      aspectRatio: 1,
      dragMode: 'move',
      modal: false,
      highlight: false,
      cropBoxMovable: false,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      rotatable: false,
      minContainerWidth: 400,
      minContainerHeight: 400,
      minCanvasWidth: 200,
      minCanvasHeight: 200,
      minCropBoxWidth: 400,
      minCropBoxHeight: 400
    })

    this.cropSuccessAction = cropSuccessAction
    this.cropCancelledAction = cropCancelledAction
  }

  close = (event): void => {
    if (event.type === 'click' || event.key === 'Escape') {
      event.preventDefault()
      this.element.classList.remove('cropper--active')
      if (event.target.innerText === 'Confirm') {
        this.cropper.getCroppedCanvas().toBlob(blob => {
          blob.cropped = true
          this.cropSuccessAction(blob)
        }, 'image/png')
      } else {
        this.cropCancelledAction()
      }
      this.cropper.destroy()
    }
  }
}
